/*
 * @Description: 富文本
 */
export default {
    label: '富文本',
    type: 'richtxt',
    property: '',
    value: '',
    options: {
        placeholder: "请输入",
    }
}
